export const Footer = (): JSX.Element => {
  return (
    <div className="footer">
      <div>Geek Utopia jest nieoficjalną i niekomercyjną stroną poświęconą popkulturze, fantastyce i wszystkiemu, co geeki lubią najbardziej. </div>
      <div>Prawa autorskie do wszelkich postaci i grafik - o ile nie napisano inaczej - należą do ich Twórców i/lub Producentów.</div>
      <div>Wszelkie materiały oryginalne </div>
      <div>©2022-2023 Geekutopia.pl</div>
      <div>Kopiowanie tekstów bez zgody autorów jest zabronione.</div>
    </div>
  );
};
